module.exports = __webpack_public_path__ + "static/media/logout-icon.7e066199.svg";